<template>
  <div>
    <div v-if="!loadingIncident">
      <page-header>
        <template #title>
          <h1 class="page-title">Send to Verify</h1>
        </template>
        <template #actions>
          <page-header-action
            tag="router-link"
            :to="`/claim-monitoring/${incident}`"
          >
            Back to Claim Monitoring
          </page-header-action>
        </template>
      </page-header>
      <send-to-verify :incident="incident"></send-to-verify>
    </div>
    <div v-else>
      <preloader></preloader>
    </div>
  </div>
</template>

<script>
import SendToVerify from '../Shared/Verify/SendToVerifyReview.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    'send-to-verify': SendToVerify,
    PageHeader,
    PageHeaderAction
  },

  computed: {
    loadingIncident() {
      return this.$store.getters['Incident/loading'];
    }
  },

  mounted() {
    this.$store.dispatch('Incident/retrieve', this.incident);
  }
};
</script>
